import * as React from 'react';

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from '@material-ui/core/styles';
import { Grid, PaperProps, Typography, Paper, Avatar } from '@material-ui/core';

// Classes
import Utility from '../../domain/classes/Utility';

// Icons
import GroupRoundedIcon from '@material-ui/icons/GroupRounded';
import DevicesRoundedIcon from '@material-ui/icons/DevicesRounded';
// import CreditCardRoundedIcon from '@material-ui/icons/CreditCardRounded';
import TimerRoundedIcon from '@material-ui/icons/TimerRounded';
import EventRoundedIcon from '@material-ui/icons/EventRounded';

// NPM
import clsx from 'clsx';

// Contexts
import { useApplicationManager } from '../../contexts/ApplicationManager.Context';
import StyledAttributeContainer from '../appointmentTypeSelection/AttributeContainer.Component';
import DateTime from '../../domain/classes/DateTime';
import moment from 'moment';

export const styles = (theme: Theme) =>
	createStyles({
		root: {
			padding: theme.spacing(2),
		},
		container: {
			display: 'flex',
		},
		imgContainer: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			marginRight: theme.spacing(2),
			[theme.breakpoints.down('xs')]: {
				marginRight: theme.spacing(1),
			},
		},
		img: { width: theme.spacing(8), height: theme.spacing(8) },
	});

export interface AppointmentDetailsProps extends PaperProps {}

const AppointmentDetails = React.forwardRef<
	HTMLDivElement,
	AppointmentDetailsProps & WithStyles<typeof styles>
>(({ className, classes, ...paperProps }, ref) => {
	// Contexts
	const {
		selectedDoctor,
		selectedApptType,
		patientDetails,
		appointmentBookingRequest,
	} = useApplicationManager();

	return (
		<Paper
			component="div"
			ref={ref}
			{...paperProps}
			square
			elevation={0}
			variant="outlined"
			className={clsx(classes.root, className)}
		>
			<div className={classes.container}>
				<div className={classes.imgContainer}>
					<Avatar
						src={selectedDoctor?.ProfilePhotoUri}
						className={classes.img}
					/>
				</div>
				<Grid container spacing={1}>
					<Grid item xs={12}>
						<Typography variant="body1" color="primary" display="inline">
							{selectedDoctor?.Title + ' ' + selectedDoctor?.Firstname + ' '}
						</Typography>
						<Typography variant="body1" color="primary" display="inline">
							<strong>{selectedDoctor?.Lastname}</strong>
						</Typography>
					</Grid>
					<Grid item xs={12}>
						<Typography variant="body1">
							{selectedApptType.appointmentTypeName}
						</Typography>
					</Grid>
					<StyledAttributeContainer
						Icon={EventRoundedIcon}
						text={moment(appointmentBookingRequest.appointmentStartTime).format(
							DateTime.FULL_DATE_DISPLAY_FORMAT
						)}
					/>
					<StyledAttributeContainer
						Icon={TimerRoundedIcon}
						text={moment(appointmentBookingRequest.appointmentStartTime).format(
							DateTime.TIME_DISPLAY_FORMAT
						)}
						minutes={selectedApptType.minimumDuration}
						hasBracketsAroundMinutes
					/>
					{/* <StyledAttributeContainer
						Icon={CreditCardRoundedIcon}
						money={selectedApptType.preDepositAmount}
					/> */}

					{patientDetails.attendancePreference === 'telehealth' && (
						<StyledAttributeContainer
							Icon={DevicesRoundedIcon}
							text="Telehealth"
						/>
					)}
					{patientDetails.attendancePreference === 'on-site' && (
						<StyledAttributeContainer
							Icon={GroupRoundedIcon}
							text="Face-to-face"
						/>
					)}
				</Grid>
			</div>
		</Paper>
	);
});

export default withStyles(styles, {
	classNamePrefix: Utility.generateClassName('AppointmentDetails'),
})(AppointmentDetails);
